import {
  callWorker,
  createSingletonWorker,
} from "../workers/createWorkerRPC.ts";

export type BVHIndexArray = Uint8Array | Uint16Array | Uint32Array;

export interface BVHGeometryGroup {
  start: number;
  count: number;
  materialIndex: number;
}

export interface SerializedMeshBVH {
  version: number;
  roots: Array<ArrayBuffer>;
  index: BVHIndexArray | null;
  indirectBuffer: Uint32Array | null;
}

export interface BuildBoundsTreeRequest {
  position: Float32Array;
  index: BVHIndexArray | null;
  groups: BVHGeometryGroup[];
}

export interface BuildBoundsTreeResult {
  serialized: SerializedMeshBVH;
}

const getWorker = createSingletonWorker(
  () =>
    new Worker(new URL("./bvh.worker.ts", import.meta.url), {
      type: "module",
    }),
);

export async function buildBoundsTreeAsync(
  request: BuildBoundsTreeRequest,
): Promise<BuildBoundsTreeResult> {
  return callWorker<BuildBoundsTreeRequest, BuildBoundsTreeResult>(
    getWorker(),
    request,
    [request.position.buffer, ...(request.index ? [request.index.buffer] : [])],
    {
      stallWarningMs: 8_000,
      stallMessage:
        "Viewport acceleration data is taking longer than expected to rebuild.",
      stallDedupKey: "viewport-bvh-build",
    },
  );
}
